// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-language',
    standalone: false,
    templateUrl: './language.component.html',
})
export class StatisticsVisitorsLanguageComponent implements OnInit {
    pageChange = this.onPageChange.bind(this);
    perPageChange = this.onPerPageChange.bind(this);
    totalVisits: number = 0;
    pageSize: number = 100;
    loading: boolean = false;
    updateDateRange = this.onUpdateDateRange.bind(this);
    average = this.calculateAverage.bind(this);

    domain: any;
    chartType: string = 'chart';
    date: any;
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    exports: any[] = [];
    pages: any[] = [];
    promise: any;
    page: any;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.chartType = 'chart';
        this.date = this.dateRangeService.setRangeDates();

        this.onUpdateDateRange();

        this.getPage();

        this.doughnutLabels = [];
        this.doughnutData = [];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
    }

    getPage () {
        const params = {
            limit: this.pageSize || 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            from: this.date.startDate?.format('YYYY-MM-DD'),
            to: this.date.endDate?.format('YYYY-MM-DD'),
        };
        this.exports = [
            {
                tooltip: this.translateService.getString('Export visitors language'),
                name: this.translateService.getString('Visitors language export'),
                data: {
                    category: 'visitors_language',
                    category_ref: this.date.startDate?.format('YYYY-MM-DD') + ',' + this.date.endDate?.format('YYYY-MM-DD'),
                },
            },
        ];
        let others = 0;
        this.loading = true;
        this.promise = this.statsRepoService.getLanguages(params)
            .then((data: any) => {
                this.pages = data;
                this.totalVisits = data.reduce((total: number, page: any) => {
                    return total + parseInt(page.visits);
                }, 0);
                this.doughnutLabels = [];
                this.doughnutData = [];
                for (let i = 0; i < this.pages.length; i++) {
                    if (i < 5) {
                        this.doughnutLabels.push(this.pages[i].label);
                        this.doughnutData.push(this.pages[i].visits);
                    } else {
                        others += parseInt(this.pages[i].visits);
                    }
                }
                if (this.pages.length > 5) {
                    this.doughnutLabels.push(this.translateService.getString('Others'));
                    this.doughnutData.push(others);
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onPageChange (page: any) {
        this.page = page;
        this.getPage();
    }

    onPerPageChange (pageSize: any) {
        this.pageSize = pageSize;
        this.getPage();
    }

    onUpdateDateRange () {
        if (this.date.startDate || this.date.endDate) {
            this.paramService.setParams({
                from: moment(this.date.startDate),
                to: moment(this.date.endDate),
            });
            this.getPage();
        }
    }

    calculateAverage (array: any, prop: string) {
        let sum = 0;
        if (!Array.isArray(array) || array.length === 0) {
            return 0;
        }
        array.forEach((item: any) => {
            sum += parseInt(item[prop]);
        });
        return sum / array.length;
    }
}
